import {ChevronDownIcon} from '@heroicons/react/24/outline';
import classNames from 'classnames';
import {ComponentProps} from 'react';

type Props = ComponentProps<'div'> & {
  enabled: boolean;
};

const ScrollBar = ({className, enabled, ...props}: Props) => {
  return (
    <div
      className={classNames(
        enabled ? 'opacity-100' : 'opacity-0',
        'flex absolute bottom-0 h-20 z-[2] w-full border-t-2 border-primary-300 text-white bg-primary-700 items-center justify-center transition-opacity duration-500 pointer-events-none',
        className
      )}
      {...props}
    >
      <ChevronDownIcon className="h-16 w-16 animate-bounce mt-2" />
    </div>
  );
};

export default ScrollBar;
